// extracted by mini-css-extract-plugin
export default {"section":"timeline_section__nL7+c","justify":"timeline_justify__nTSAj","heading":"timeline_heading__CRPGF"};